import * as d3 from "d3";
import { useEffect } from 'react';
import imageToBase64 from 'image-to-base64/browser';

import loadImage from "../../../noncomponents/loadImage"
import getFilter from "../../../noncomponents/getFilter"
// import setLandschapAndPartijen from "../../../noncomponents/setLandschapAndPartijen"

function IconImage({ data, d, i, iconOpacity, circleR, circleWidth, setHoverSelection,
  setClickSelection, connectionChains, clickSelection, chainSelection,
  setChainSelection, hoverSelection, circleWidthImpacts,
  setLandschapOptions, setPartijenOptions, landschapOptions, partijenOptions }) {

  const imgClassName = 'image_' + d['oorzaakeffectimpact_kort'].replaceAll(' ', '').replaceAll('(','').replaceAll(')','').replaceAll('/','').replaceAll(',', '')
  const imgClassName_clickSelection = (clickSelection >= 0)
    ? 'image_' + data.filter(d => +d.ID === clickSelection)[0]['oorzaakeffectimpact_kort'].replaceAll(' ', '').replaceAll('(','').replaceAll(')','').replaceAll('/','').replaceAll(',', '')
    : '';

  const img = loadImage(d);


  useEffect(() => {
    imageToBase64(img) // Path to the image
      .then(
          (response) => {
              d3.select('.' + imgClassName)
                .attr('href', "data:image/jpeg;charset=utf-8;base64," + response)
          }
      ).catch((error) => {console.log(error);})
  }, [img, imgClassName])


  //////////////////////////////////////////////////////////////////////////////
  // Blinking icon
  //////////////////////////////////////////////////////////////////////////////

  function fadeOutAndIn(element){
    element.transition()
      .delay(function(d, i) { return i * 50; })
      .on("start", function repeat() {
          element
          .transition('fade').duration(1200).ease(d3.easeQuad)
            .attr('opacity', 0.4)
          .transition('fade').duration(1200).ease(d3.easeQuad)
            .attr('opacity', 1)
          .transition()
            .on("start", function() {
              const selected = d3.select('.' + imgClassName_clickSelection).classed('selected');
              const burgerMenuHidden = d3.select('.bm-menu-wrap').attr('hidden');
              if(selected && burgerMenuHidden){
                repeat();
              }
            });
        });
  }

  function shouldIBlink(){
    if(clickSelection >= 0){
      if(
        // blink if depth is 2 and the icon is in the selected chain
        connectionChains[clickSelection]['depthOfIcons'][+d.ID] === 2 &&
        connectionChains[chainSelection]['chainIcons'].includes(+d.ID)
      ){
        return true;
      }
    }
    return false;
  }

  useEffect(() => {
    const imageElement = d3.select('.' + imgClassName);
    if(shouldIBlink()){
      // fadeOutAndIn(imageElement);
    }else{
      // stop the transitions and set the opacity right
      d3.select('.' + imgClassName).interrupt('fade');
      d3.select('.' + imgClassName).attr('opacity', iconOpacity);
      d3.select('.circle' + imgClassName).attr('opacity', Math.ceil(iconOpacity));
    }
  }, [clickSelection, iconOpacity, imgClassName])


  //////////////////////////////////////////////////////////////////////////////
  // Mouse interactions
  //////////////////////////////////////////////////////////////////////////////

  function hover(){
    // d3.selectAll('.categoryText').attr('opacity', 0);
    if(clickSelection < 0){
      setHoverSelection(+d.ID);
    }
  }

  function mouseOut(){
    setHoverSelection(-1);
  }

  function click(){

    console.log(d)
    console.log(imgClassName)

    // only click if nothing else is clicked or in the chainIcons
    if(
      clickSelection < 0 ||
      (
        clickSelection >= 0 &&
        connectionChains[chainSelection]['chainIcons'].includes(+d.ID)
      )
    ){
      d3.selectAll('image')
        .classed('selected', false)
        .transition().duration(0);

      d3.select('.' + imgClassName).node().classList.add("selected");
      setClickSelection(+d.ID);
      if(chainSelection < 0){

        // setLandschapAndPartijen(data, connectionChains, +d.ID,
        //   setLandschapOptions, setPartijenOptions, false);

        setChainSelection(+d.ID);
      }
    }
  }


  //////////////////////////////////////////////////////////////////////////////
  // Icon attributes
  //////////////////////////////////////////////////////////////////////////////

  // pointer events should not work when an icon is clicked and the hovered
  // icon is not in the chain of the clicked icon
  let pointerEvents = 'none';
  let cursor = 'default';
  if(
    (clickSelection >= 0 &&
    connectionChains[chainSelection]['chainIcons'].includes(+d.ID)) ||
    (clickSelection < 0 &&
    (d.typenr === '4' || clickSelection >= 0))
  ){
    pointerEvents = 'auto';
    cursor = 'pointer';
  }

  let filter = '';
  [filter, iconOpacity] = getFilter(d, clickSelection, connectionChains, hoverSelection,
    iconOpacity, chainSelection, landschapOptions, partijenOptions);

  let strokeWidth = 0.3;
  let strokeDasharray = '';
  let stroke = '#acacac';
  let shadowFilter = '';
  if(chainSelection === +d.ID){
    strokeWidth = 4;
    stroke = '#f28f2d';
    shadowFilter = 'url(#shadow)';
  }else if(clickSelection === +d.ID){
    strokeWidth = 4;
    strokeDasharray = '5,5';
  }

  let circleRTotal = circleR - 1;
  if(d.typenr === '4'){
    circleRTotal = circleWidthImpacts/2 + strokeWidth/4
  }

  //////////////////////////////////////////////////////////////////////////////
  // JSX
  //////////////////////////////////////////////////////////////////////////////

  return (
    <g cursor={cursor} onClick={() => click()}>

      {/* white filled circle to give the image a white background */}
      <circle className={'circle' + imgClassName}
        r={circleRTotal} stroke={stroke} fill='white' opacity={Math.ceil(iconOpacity)}
        strokeWidth={strokeWidth} strokeDasharray={strokeDasharray}
        filter={shadowFilter}
      />

      <image
        key={d + i}
        className={imgClassName}
        x={-circleRTotal}
        y={-circleRTotal}
        width={2*circleRTotal}
        height={2*circleRTotal}
        opacity={iconOpacity}
        onMouseOver={() => hover()}
        onMouseOut={() => mouseOut()}
        pointerEvents={pointerEvents}
        cursor={cursor}
        filter={filter}
        preserveAspectRatio="xMidYMid meet"
      />
    </g>
  );
}

export default IconImage;
